import { useToggle } from "client/hooks/utils/useToggle";
import { useState } from "react";
import { ColorChangeHandler } from "react-color";
import { setSettings } from "store/features/memeGenerator/actions";
import { MAX_OUTLINE_SIZE } from "store/features/memeGenerator/data/configs";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useOutline = (textBox: TextBox) => {
    const dispatch = useAppDispatch();
    const { isOpen, onClose: close, toggle } = useToggle();
    function handleOutlineChange(value: number) {
        const outline = textBox.outline;
        if (!outline) throw new Error("Outline width accessed without outline activated");
        if (value < 0 || value > MAX_OUTLINE_SIZE || isNaN(value)) throw new Error(`Invalid outline width: ${value}`);
        dispatch(
            setSettings({
                id: textBox.id,
                outline: {
                    ...outline,
                    size: value,
                },
            }),
        );
    }
    const handleColorChange: ColorChangeHandler = (color) => {
        if (!textBox.outline?.isActive) throw new Error("Outline not activated");
        setOutlineColor(color.hex);
    };
    function setOutlineColor(color: string) {
        if (!textBox.outline) return;
        dispatch(
            setSettings({
                id: textBox.id,
                outline: {
                    ...textBox.outline,
                    color: color,
                },
            }),
        );
    }
    const [bottomModalColorValue, setBottomModalColorValue] = useState("");
    function onApprove(color: string) {
        close();
        setOutlineColor(color);
    }
    return {
        handleOutlineChange,
        isOpen,
        close,
        toggle,
        handleColorChange,
        bottomModalColorValue,
        setBottomModalColorValue,
        onApprove,
    };
};
